import PropTypes from 'prop-types';
import { InputNumber, Input, Select, Radio, Rate } from 'antd';
import { optionsFromLabels } from '../../constants/personal-survey-fields';
import styles from '../../styles/personal-survey.module.scss';

const SurveyFieldInput = ({ field, value, onChange, status }) => {
  if (field.type === 'select') {
    return (
      <Select
        value={value ?? undefined}
        onChange={onChange}
        options={optionsFromLabels(field.options)}
        placeholder={field.label}
        style={{ width: '100%' }}
        allowClear
        status={status}
      />
    );
  }

  if (field.type === 'multiselect') {
    return (
      <Select
        mode="multiple"
        className={styles.multiSelect}
        value={Array.isArray(value) ? value : []}
        onChange={onChange}
        options={optionsFromLabels(field.options)}
        placeholder={field.label}
        style={{ width: '100%' }}
        maxCount={field.maxSelect}
        status={status}
      />
    );
  }

  if (field.type === 'number') {
    return (
      <InputNumber
        className={styles.numberInput}
        value={value ?? undefined}
        onChange={onChange}
        min={field.min}
        max={field.max}
        style={{ width: '100%' }}
        status={status}
      />
    );
  }

  if (field.type === 'text') {
    return (
      <Input
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        status={status}
      />
    );
  }

  if (field.type === 'boolean') {
    return (
      <Radio.Group
        className={styles.boolRadioGroup}
        value={value ?? undefined}
        onChange={(e) => onChange(e.target.value)}
      >
        <Radio value={true}>Da</Radio>
        <Radio value={false}>Ne</Radio>
      </Radio.Group>
    );
  }

  if (field.type === 'rating') {
    return (
      <Rate
        count={field.max ?? 5}
        value={value ?? 0}
        onChange={onChange}
      />
    );
  }

  return null;
};

SurveyFieldInput.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  status: PropTypes.oneOf(['error', 'warning']),
};

export default SurveyFieldInput;
